import { Outlet } from "react-router-dom";
import './App.css';
import Navbar from './components/Navbar';
import CursorFx from './components/CursorFx';

export default function Layout() {
    
    return (
        <div className="app-shell min-h-screen">
            <Navbar />
            <CursorFx />
            <main className="pb-10">
                
                <Outlet />
            </main>
        </div>
    );
}
